import { useState, useEffect } from "react";
import { wsNotify } from "../api/ws/ws-notify";

export const useNotify = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const ws = wsNotify();
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        setNotifications((prev) => [data, ...prev]);
      } catch (err) {
        console.error("❌ Invalid WS message:", err);
      }
    };

    ws.onerror = (err) => {
      console.error("⚠️ WS Error:", err);
    };

    return () => {
      if (
        ws.readyState === WebSocket.OPEN ||
        ws.readyState === WebSocket.CONNECTING
      ) {
        ws.close();
      }
    };
  }, []);

  const resetState = () => {
    setNotifications([]);
  };

  return { 
    notifications, 
    setNotifications, 
    resetState };
};
